module.exports = __webpack_public_path__ + "assets/img/thumb-AquavistaGlass-Website.4c001c2a.jpg";